export const signupWithTypeTranslations = {
  en: {
    'signup.upgradeGuest': 'Upgrade Your Guest Account',
    'signup.createAccount': 'Create Your Account',
    'signup.convertGuest': 'Convert your guest account ({guestUsername}) to a full account',
    'signup.chooseAccount': 'Choose your account type and get started',
    'signup.accountType': 'Account Type',
    'signup.individual': 'Individual',
    'signup.individualDesc': 'Personal account for payments and transfers',
    'signup.merchant': 'Merchant',
    'signup.merchantDesc': 'Business account with selling tools',
    'signup.bank': 'Bank',
    'signup.bankDesc': 'Financial institution integration',
    'signup.bankAuthNotice': 'Bank registration requires a valid Bank Authentication Token issued by the platform administrator.',
    'signup.bankAuthToken': 'Bank Authentication Token',
    'signup.bankAuthTokenPlaceholder': 'Enter your bank authentication token',
    'signup.email': 'Email Address',
    'signup.emailPlaceholder': 'you@example.com',
    'signup.password': 'Password',
    'signup.passwordPlaceholder': 'Create a strong password',
    'signup.confirmPassword': 'Confirm Password',
    'signup.confirmPasswordPlaceholder': 'Re-enter your password',
    'signup.creatingAccount': 'Creating Account...',
    'signup.createPersonal': 'Create Personal Account',
    'signup.createMerchant': 'Create Merchant Account',
    'signup.createBank': 'Create Bank Account',
    'signup.orContinueWith': 'Or continue with',
    'signup.haveAccount': 'Already have an account?',
    'signup.signIn': 'Sign in',
    'signup.errors.emailRequired': 'Email is required',
    'signup.errors.invalidEmail': 'Please enter a valid email address',
    'signup.errors.passwordRequired': 'Password is required',
    'signup.errors.confirmPasswordRequired': 'Please confirm your password',
    'signup.errors.passwordsMismatch': 'Passwords do not match',
    'signup.errors.bankAuthRequired': 'Bank Authentication Token is required',
    'signup.errors.registrationFailed': 'Registration failed',
    'signup.errors.emailTaken': 'This email is already registered',
    'signup.errors.invalidBankToken': 'Invalid Bank Authentication Token',
    'signup.errors.googleSignInFailed': 'Google Sign-In failed. Please try again.',
    'signup.success.registration': 'Registration successful! Logging you in...',
    'signup.success.google': 'Google Sign-In successful!',
    'signup.passwordStrength.veryWeak': 'Very Weak',
    'signup.passwordStrength.weak': 'Weak',
    'signup.passwordStrength.medium': 'Medium',
    'signup.passwordStrength.strong': 'Strong',
    'signup.passwordStrength.veryStrong': 'Very Strong',
  },
  es: {
    'signup.upgradeGuest': 'Actualiza tu Cuenta de Invitado',
    'signup.createAccount': 'Crea tu Cuenta',
    'signup.convertGuest': 'Convierte tu cuenta de invitado ({guestUsername}) en una cuenta completa',
    'signup.chooseAccount': 'Elige tu tipo de cuenta y comienza',
    'signup.accountType': 'Tipo de Cuenta',
    'signup.individual': 'Individual',
    'signup.individualDesc': 'Cuenta personal para pagos y transferencias',
    'signup.merchant': 'Comerciante',
    'signup.merchantDesc': 'Cuenta de empresa con herramientas de venta',
    'signup.bank': 'Banco',
    'signup.bankDesc': 'Integración de institución financiera',
    'signup.bankAuthNotice': 'El registro bancario requiere un Token de Autenticación Bancaria válido emitido por el administrador de la plataforma.',
    'signup.bankAuthToken': 'Token de Autenticación Bancaria',
    'signup.bankAuthTokenPlaceholder': 'Introduce tu token de autenticación bancaria',
    'signup.email': 'Dirección de Correo Electrónico',
    'signup.emailPlaceholder': 'tu@ejemplo.com',
    'signup.password': 'Contraseña',
    'signup.passwordPlaceholder': 'Crea una contraseña segura',
    'signup.confirmPassword': 'Confirmar Contraseña',
    'signup.confirmPasswordPlaceholder': 'Vuelve a introducir tu contraseña',
    'signup.creatingAccount': 'Creando Cuenta...',
    'signup.createPersonal': 'Crear Cuenta Personal',
    'signup.createMerchant': 'Crear Cuenta de Comerciante',
    'signup.createBank': 'Crear Cuenta Bancaria',
    'signup.orContinueWith': 'O continuar con',
    'signup.haveAccount': '¿Ya tienes una cuenta?',
    'signup.signIn': 'Iniciar sesión',
    'signup.errors.emailRequired': 'Se requiere correo electrónico',
    'signup.errors.invalidEmail': 'Por favor, introduce una dirección de correo electrónico válida',
    'signup.errors.passwordRequired': 'Se requiere contraseña',
    'signup.errors.confirmPasswordRequired': 'Por favor, confirma tu contraseña',
    'signup.errors.passwordsMismatch': 'Las contraseñas no coinciden',
    'signup.errors.bankAuthRequired': 'Se requiere el Token de Autenticación Bancaria',
    'signup.errors.registrationFailed': 'Falló el registro',
    'signup.errors.emailTaken': 'Este correo electrónico ya está registrado',
    'signup.errors.invalidBankToken': 'Token de Autenticación Bancaria no válido',
    'signup.errors.googleSignInFailed': 'Falló el inicio de sesión con Google. Por favor, inténtalo de nuevo.',
    'signup.success.registration': '¡Registro exitoso! Iniciando sesión...',
    'signup.success.google': '¡Inicio de sesión con Google exitoso!',
    'signup.passwordStrength.veryWeak': 'Muy Débil',
    'signup.passwordStrength.weak': 'Débil',
    'signup.passwordStrength.medium': 'Mediana',
    'signup.passwordStrength.strong': 'Fuerte',
    'signup.passwordStrength.veryStrong': 'Muy Fuerte',
  },
  fr: {
    'signup.upgradeGuest': 'Mettre à niveau votre compte invité',
    'signup.createAccount': 'Créer votre compte',
    'signup.convertGuest': 'Convertir votre compte invité ({guestUsername}) en compte complet',
    'signup.chooseAccount': 'Choisissez votre type de compte et commencez',
    'signup.accountType': 'Type de compte',
    'signup.individual': 'Individuel',
    'signup.individualDesc': 'Compte personnel pour paiements et transferts',
    'signup.merchant': 'Marchand',
    'signup.merchantDesc': 'Compte professionnel avec outils de vente',
    'signup.bank': 'Banque',
    'signup.bankDesc': 'Intégration d\'institution financière',
    'signup.bankAuthNotice': 'L\'enregistrement bancaire nécessite un token d\'authentification bancaire valide délivré par l\'administrateur de la plateforme.',
    'signup.bankAuthToken': 'Token d\'authentification bancaire',
    'signup.bankAuthTokenPlaceholder': 'Entrez votre token d\'authentification bancaire',
    'signup.email': 'Adresse e-mail',
    'signup.emailPlaceholder': 'vous@exemple.com',
    'signup.password': 'Mot de passe',
    'signup.passwordPlaceholder': 'Créez un mot de passe fort',
    'signup.confirmPassword': 'Confirmer le mot de passe',
    'signup.confirmPasswordPlaceholder': 'Ré-entrez votre mot de passe',
    'signup.creatingAccount': 'Création du compte...',
    'signup.createPersonal': 'Créer un compte personnel',
    'signup.createMerchant': 'Créer un compte marchand',
    'signup.createBank': 'Créer un compte bancaire',
    'signup.orContinueWith': 'Ou continuer avec',
    'signup.haveAccount': 'Vous avez déjà un compte ?',
    'signup.signIn': 'Se connecter',
    'signup.errors.emailRequired': 'L\'e-mail est requis',
    'signup.errors.invalidEmail': 'Veuillez entrer une adresse e-mail valide',
    'signup.errors.passwordRequired': 'Le mot de passe est requis',
    'signup.errors.confirmPasswordRequired': 'Veuillez confirmer votre mot de passe',
    'signup.errors.passwordsMismatch': 'Les mots de passe ne correspondent pas',
    'signup.errors.bankAuthRequired': 'Le token d\'authentification bancaire est requis',
    'signup.errors.registrationFailed': 'L\'enregistrement a échoué',
    'signup.errors.emailTaken': 'Cet e-mail est déjà enregistré',
    'signup.errors.invalidBankToken': 'Token d\'authentification bancaire invalide',
    'signup.errors.googleSignInFailed': 'La connexion Google a échoué. Veuillez réessayer.',
    'signup.success.registration': 'Enregistrement réussi ! Connexion en cours...',
    'signup.success.google': 'Connexion Google réussie !',
    'signup.passwordStrength.veryWeak': 'Très faible',
    'signup.passwordStrength.weak': 'Faible',
    'signup.passwordStrength.medium': 'Moyen',
    'signup.passwordStrength.strong': 'Fort',
    'signup.passwordStrength.veryStrong': 'Très fort',
  },
  sq: {
    'signup.upgradeGuest': 'Përmirësoni Llogarinë tuaj të Mysafirit',
    'signup.createAccount': 'Krijoni Llogarinë tuaj',
    'signup.convertGuest': 'Konvertoni llogarinë tuaj të mysafirit ({guestUsername}) në një llogari të plotë',
    'signup.chooseAccount': 'Zgjidhni llojin e llogarisë dhe filloni',
    'signup.accountType': 'Lloji i Llogarisë',
    'signup.individual': 'Individual',
    'signup.individualDesc': 'Llogari personale për pagesa dhe transferta',
    'signup.merchant': 'Tregtar',
    'signup.merchantDesc': 'Llogari biznesi me mjete shitjeje',
    'signup.bank': 'Banka',
    'signup.bankDesc': 'Integrim institucioni financiar',
    'signup.bankAuthNotice': 'Regjistrimi bankar kërkon një Token Autentifikimi Bankar të vlefshëm të lëshuar nga administratori i platformës.',
    'signup.bankAuthToken': 'Token Autentifikimi Bankar',
    'signup.bankAuthTokenPlaceholder': 'Vendosni tokenin tuaj të autentifikimit bankar',
    'signup.email': 'Adresa Email',
    'signup.emailPlaceholder': 'ju@shembull.com',
    'signup.password': 'Fjalëkalimi',
    'signup.passwordPlaceholder': 'Krijoni një fjalëkalim të fortë',
    'signup.confirmPassword': 'Konfirmoni Fjalëkalimin',
    'signup.confirmPasswordPlaceholder': 'Vendosni përsëri fjalëkalimin tuaj',
    'signup.creatingAccount': 'Duke krijuar llogarinë...',
    'signup.createPersonal': 'Krijoni Llogari Personale',
    'signup.createMerchant': 'Krijoni Llogari Tregtari',
    'signup.createBank': 'Krijoni Llogari Bankare',
    'signup.orContinueWith': 'Ose vazhdoni me',
    'signup.haveAccount': 'Tashmë keni një llogari?',
    'signup.signIn': 'Hyr',
    'signup.errors.emailRequired': 'Email është i nevojshëm',
    'signup.errors.invalidEmail': 'Ju lutem vendosni një adresë email të vlefshme',
    'signup.errors.passwordRequired': 'Fjalëkalimi është i nevojshëm',
    'signup.errors.confirmPasswordRequired': 'Ju lutem konfirmoni fjalëkalimin tuaj',
    'signup.errors.passwordsMismatch': 'Fjalëkalimet nuk përputhen',
    'signup.errors.bankAuthRequired': 'Token Autentifikimi Bankar është i nevojshëm',
    'signup.errors.registrationFailed': 'Regjistrimi dështoi',
    'signup.errors.emailTaken': 'Ky email është tashmë i regjistruar',
    'signup.errors.invalidBankToken': 'Token Autentifikimi Bankar i pavlefshëm',
    'signup.errors.googleSignInFailed': 'Hyrja me Google dështoi. Ju lutem provoni përsëri.',
    'signup.success.registration': 'Regjistrimi i suksesshëm! Po ju kyçim...',
    'signup.success.google': 'Hyrja me Google e suksesshme!',
    'signup.passwordStrength.veryWeak': 'Shumë i Dobët',
    'signup.passwordStrength.weak': 'I Dobët',
    'signup.passwordStrength.medium': 'Mesatar',
    'signup.passwordStrength.strong': 'I Fortë',
    'signup.passwordStrength.veryStrong': 'Shumë i Fortë',
  },
  ru: {
    'signup.upgradeGuest': 'Обновите ваш гостевой аккаунт',
    'signup.createAccount': 'Создайте ваш аккаунт',
    'signup.convertGuest': 'Преобразуйте ваш гостевой аккаунт ({guestUsername}) в полный аккаунт',
    'signup.chooseAccount': 'Выберите тип аккаунта и начните',
    'signup.accountType': 'Тип аккаунта',
    'signup.individual': 'Физическое лицо',
    'signup.individualDesc': 'Личный аккаунт для платежей и переводов',
    'signup.merchant': 'Продавец',
    'signup.merchantDesc': 'Бизнес-аккаунт с инструментами продажи',
    'signup.bank': 'Банк',
    'signup.bankDesc': 'Интеграция финансового учреждения',
    'signup.bankAuthNotice': 'Регистрация банка требует действительный Токен Аутентификации Банка, выданный администратором платформы.',
    'signup.bankAuthToken': 'Токен Аутентификации Банка',
    'signup.bankAuthTokenPlaceholder': 'Введите ваш токен аутентификации банка',
    'signup.email': 'Адрес электронной почты',
    'signup.emailPlaceholder': 'вы@пример.com',
    'signup.password': 'Пароль',
    'signup.passwordPlaceholder': 'Создайте надежный пароль',
    'signup.confirmPassword': 'Подтвердите пароль',
    'signup.confirmPasswordPlaceholder': 'Повторно введите ваш пароль',
    'signup.creatingAccount': 'Создание аккаунта...',
    'signup.createPersonal': 'Создать личный аккаунт',
    'signup.createMerchant': 'Создать аккаунт продавца',
    'signup.createBank': 'Создать банковский аккаунт',
    'signup.orContinueWith': 'Или продолжить с',
    'signup.haveAccount': 'Уже есть аккаунт?',
    'signup.signIn': 'Войти',
    'signup.errors.emailRequired': 'Email обязателен',
    'signup.errors.invalidEmail': 'Пожалуйста, введите действительный адрес email',
    'signup.errors.passwordRequired': 'Пароль обязателен',
    'signup.errors.confirmPasswordRequired': 'Пожалуйста, подтвердите ваш пароль',
    'signup.errors.passwordsMismatch': 'Пароли не совпадают',
    'signup.errors.bankAuthRequired': 'Токен Аутентификации Банка обязателен',
    'signup.errors.registrationFailed': 'Регистрация не удалась',
    'signup.errors.emailTaken': 'Этот email уже зарегистрирован',
    'signup.errors.invalidBankToken': 'Неверный Токен Аутентификации Банка',
    'signup.errors.googleSignInFailed': 'Вход через Google не удался. Пожалуйста, попробуйте снова.',
    'signup.success.registration': 'Регистрация успешна! Выполняется вход...',
    'signup.success.google': 'Вход через Google успешен!',
    'signup.passwordStrength.veryWeak': 'Очень слабый',
    'signup.passwordStrength.weak': 'Слабый',
    'signup.passwordStrength.medium': 'Средний',
    'signup.passwordStrength.strong': 'Сильный',
    'signup.passwordStrength.veryStrong': 'Очень сильный',
  },
  pt: {
    'signup.upgradeGuest': 'Atualize Sua Conta de Visitante',
    'signup.createAccount': 'Crie Sua Conta',
    'signup.convertGuest': 'Converta sua conta de visitante ({guestUsername}) em uma conta completa',
    'signup.chooseAccount': 'Escolha seu tipo de conta e comece',
    'signup.accountType': 'Tipo de Conta',
    'signup.individual': 'Individual',
    'signup.individualDesc': 'Conta pessoal para pagamentos e transferências',
    'signup.merchant': 'Comerciante',
    'signup.merchantDesc': 'Conta comercial com ferramentas de venda',
    'signup.bank': 'Banco',
    'signup.bankDesc': 'Integração de instituição financeira',
    'signup.bankAuthNotice': 'O registro bancário requer um Token de Autenticação Bancária válido emitido pelo administrador da plataforma.',
    'signup.bankAuthToken': 'Token de Autenticação Bancária',
    'signup.bankAuthTokenPlaceholder': 'Digite seu token de autenticação bancária',
    'signup.email': 'Endereço de Email',
    'signup.emailPlaceholder': 'voce@exemplo.com',
    'signup.password': 'Senha',
    'signup.passwordPlaceholder': 'Crie uma senha forte',
    'signup.confirmPassword': 'Confirmar Senha',
    'signup.confirmPasswordPlaceholder': 'Digite novamente sua senha',
    'signup.creatingAccount': 'Criando Conta...',
    'signup.createPersonal': 'Criar Conta Pessoal',
    'signup.createMerchant': 'Criar Conta de Comerciante',
    'signup.createBank': 'Criar Conta Bancária',
    'signup.orContinueWith': 'Ou continue com',
    'signup.haveAccount': 'Já tem uma conta?',
    'signup.signIn': 'Entrar',
    'signup.errors.emailRequired': 'Email é necessário',
    'signup.errors.invalidEmail': 'Por favor, digite um endereço de email válido',
    'signup.errors.passwordRequired': 'Senha é necessária',
    'signup.errors.confirmPasswordRequired': 'Por favor, confirme sua senha',
    'signup.errors.passwordsMismatch': 'As senhas não coincidem',
    'signup.errors.bankAuthRequired': 'Token de Autenticação Bancária é necessário',
    'signup.errors.registrationFailed': 'Registro falhou',
    'signup.errors.emailTaken': 'Este email já está registrado',
    'signup.errors.invalidBankToken': 'Token de Autenticação Bancária inválido',
    'signup.errors.googleSignInFailed': 'Login com Google falhou. Tente novamente.',
    'signup.success.registration': 'Registro bem-sucedido! Fazendo login...',
    'signup.success.google': 'Login com Google bem-sucedido!',
    'signup.passwordStrength.veryWeak': 'Muito Fraco',
    'signup.passwordStrength.weak': 'Fraco',
    'signup.passwordStrength.medium': 'Médio',
    'signup.passwordStrength.strong': 'Forte',
    'signup.passwordStrength.veryStrong': 'Muito Forte',
  },
  el: {
    'signup.upgradeGuest': 'Αναβάθμιση του Λογαριασμού Επισκέπτη',
    'signup.createAccount': 'Δημιουργία Λογαριασμού',
    'signup.convertGuest': 'Μετατροπή του λογαριασμού επισκέπτη ({guestUsername}) σε πλήρη λογαριασμό',
    'signup.chooseAccount': 'Επιλέξτε τον τύπο λογαριασμού σας και ξεκινήστε',
    'signup.accountType': 'Τύπος Λογαριασμού',
    'signup.individual': 'Ατομικός',
    'signup.individualDesc': 'Προσωπικός λογαριασμός για πληρωμές και μεταφορές',
    'signup.merchant': 'Έμπορος',
    'signup.merchantDesc': 'Επαγγελματικός λογαριασμός με εργαλεία πώλησης',
    'signup.bank': 'Τράπεζα',
    'signup.bankDesc': 'Ενσωμάτωση χρηματοπιστωτικού ιδρύματος',
    'signup.bankAuthNotice': 'Η εγγραφή τράπεζας απαιτεί ένα έγκυρο Token Επαλήθευσης Τράπεζας που εκδίδεται από τον διαχειριστή της πλατφόρμας.',
    'signup.bankAuthToken': 'Token Επαλήθευσης Τράπεζας',
    'signup.bankAuthTokenPlaceholder': 'Εισάγετε το token επαλήθευσης τράπεζας',
    'signup.email': 'Διεύθυνση Email',
    'signup.emailPlaceholder': 'εσείς@παράδειγμα.com',
    'signup.password': 'Κωδικός Πρόσβασης',
    'signup.passwordPlaceholder': 'Δημιουργήστε έναν ισχυρό κωδικό πρόσβασης',
    'signup.confirmPassword': 'Επιβεβαίωση Κωδικού',
    'signup.confirmPasswordPlaceholder': 'Εισάγετε ξανά τον κωδικό πρόσβασης',
    'signup.creatingAccount': 'Δημιουργία Λογαριασμού...',
    'signup.createPersonal': 'Δημιουργία Προσωπικού Λογαριασμού',
    'signup.createMerchant': 'Δημιουργία Λογαριασμού Εμπόρου',
    'signup.createBank': 'Δημιουργία Τραπεζικού Λογαριασμού',
    'signup.orContinueWith': 'Ή συνεχίστε με',
    'signup.haveAccount': 'Έχετε ήδη λογαριασμό;',
    'signup.signIn': 'Σύνδεση',
    'signup.errors.emailRequired': 'Το email είναι υποχρεωτικό',
    'signup.errors.invalidEmail': 'Παρακαλώ εισάγετε μια έγκυρη διεύθυνση email',
    'signup.errors.passwordRequired': 'Ο κωδικός πρόσβασης είναι υποχρεωτικός',
    'signup.errors.confirmPasswordRequired': 'Παρακαλώ επιβεβαιώστε τον κωδικό πρόσβασης',
    'signup.errors.passwordsMismatch': 'Οι κωδικοί πρόσβασης δεν ταιριάζουν',
    'signup.errors.bankAuthRequired': 'Το Token Επαλήθευσης Τράπεζας είναι υποχρεωτικό',
    'signup.errors.registrationFailed': 'Η εγγραφή απέτυχε',
    'signup.errors.emailTaken': 'Αυτό το email είναι ήδη εγγεγραμμένο',
    'signup.errors.invalidBankToken': 'Μη έγκυρο Token Επαλήθευσης Τράπεζας',
    'signup.errors.googleSignInFailed': 'Η σύνδεση με το Google απέτυχε. Παρακαλώ δοκιμάστε ξανά.',
    'signup.success.registration': 'Η εγγραφή ολοκληρώθηκε με επιτυχία! Σύνδεση...',
    'signup.success.google': 'Η σύνδεση με το Google ολοκληρώθηκε με επιτυχία!',
    'signup.passwordStrength.veryWeak': 'Πολύ Αδύναμος',
    'signup.passwordStrength.weak': 'Αδύναμος',
    'signup.passwordStrength.medium': 'Μέτριος',
    'signup.passwordStrength.strong': 'Ισχυρός',
    'signup.passwordStrength.veryStrong': 'Πολύ Ισχυρός',
  },
  de: {
    'signup.upgradeGuest': 'Gastkonto upgraden',
    'signup.createAccount': 'Ihr Konto erstellen',
    'signup.convertGuest': 'Konvertieren Sie Ihr Gastkonto ({guestUsername}) in ein vollständiges Konto',
    'signup.chooseAccount': 'Wählen Sie Ihren Kontotyp und beginnen Sie',
    'signup.accountType': 'Kontotyp',
    'signup.individual': 'Privatperson',
    'signup.individualDesc': 'Persönliches Konto für Zahlungen und Überweisungen',
    'signup.merchant': 'Händler',
    'signup.merchantDesc': 'Geschäftskonto mit Verkaufstools',
    'signup.bank': 'Bank',
    'signup.bankDesc': 'Integration von Finanzinstituten',
    'signup.bankAuthNotice': 'Die Bankregistrierung erfordert ein gültiges Bank-Authentifizierungs-Token, das vom Plattformadministrator ausgestellt wurde.',
    'signup.bankAuthToken': 'Bank-Authentifizierungs-Token',
    'signup.bankAuthTokenPlaceholder': 'Geben Sie Ihr Bank-Authentifizierungs-Token ein',
    'signup.email': 'E-Mail-Adresse',
    'signup.emailPlaceholder': 'sie@beispiel.com',
    'signup.password': 'Passwort',
    'signup.passwordPlaceholder': 'Erstellen Sie ein sicheres Passwort',
    'signup.confirmPassword': 'Passwort bestätigen',
    'signup.confirmPasswordPlaceholder': 'Geben Sie Ihr Passwort erneut ein',
    'signup.creatingAccount': 'Konto wird erstellt...',
    'signup.createPersonal': 'Persönliches Konto erstellen',
    'signup.createMerchant': 'Händlerkonto erstellen',
    'signup.createBank': 'Bankkonto erstellen',
    'signup.orContinueWith': 'Oder fortfahren mit',
    'signup.haveAccount': 'Bereits ein Konto?',
    'signup.signIn': 'Anmelden',
    'signup.errors.emailRequired': 'E-Mail ist erforderlich',
    'signup.errors.invalidEmail': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    'signup.errors.passwordRequired': 'Passwort ist erforderlich',
    'signup.errors.confirmPasswordRequired': 'Bitte bestätigen Sie Ihr Passwort',
    'signup.errors.passwordsMismatch': 'Passwörter stimmen nicht überein',
    'signup.errors.bankAuthRequired': 'Bank-Authentifizierungs-Token ist erforderlich',
    'signup.errors.registrationFailed': 'Registrierung fehlgeschlagen',
    'signup.errors.emailTaken': 'Diese E-Mail ist bereits registriert',
    'signup.errors.invalidBankToken': 'Ungültiges Bank-Authentifizierungs-Token',
    'signup.errors.googleSignInFailed': 'Google-Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    'signup.success.registration': 'Registrierung erfolgreich! Sie werden angemeldet...',
    'signup.success.google': 'Google-Anmeldung erfolgreich!',
    'signup.passwordStrength.veryWeak': 'Sehr schwach',
    'signup.passwordStrength.weak': 'Schwach',
    'signup.passwordStrength.medium': 'Mittel',
    'signup.passwordStrength.strong': 'Stark',
    'signup.passwordStrength.veryStrong': 'Sehr stark',
  },
  ro: {
    'signup.upgradeGuest': 'Actualizați Contul dvs. de Vizitator',
    'signup.createAccount': 'Creați Contul dvs.',
    'signup.convertGuest': 'Convertește contul dvs. de vizitator ({guestUsername}) într-un cont complet',
    'signup.chooseAccount': 'Alegeți tipul de cont și începeți',
    'signup.accountType': 'Tip Cont',
    'signup.individual': 'Individual',
    'signup.individualDesc': 'Cont personal pentru plăți și transferuri',
    'signup.merchant': 'Comerciant',
    'signup.merchantDesc': 'Cont de afaceri cu instrumente de vânzare',
    'signup.bank': 'Bancă',
    'signup.bankDesc': 'Integrare instituție financiară',
    'signup.bankAuthNotice': 'Înregistrarea bancară necesită un Token de Autentificare Bancară valid emis de administratorul platformei.',
    'signup.bankAuthToken': 'Token de Autentificare Bancară',
    'signup.bankAuthTokenPlaceholder': 'Introduceți tokenul dvs. de autentificare bancară',
    'signup.email': 'Adresă Email',
    'signup.emailPlaceholder': 'tu@exemplu.com',
    'signup.password': 'Parolă',
    'signup.passwordPlaceholder': 'Creați o parolă puternică',
    'signup.confirmPassword': 'Confirmă Parola',
    'signup.confirmPasswordPlaceholder': 'Reintroduceți parola',
    'signup.creatingAccount': 'Se creează contul...',
    'signup.createPersonal': 'Creează Cont Personal',
    'signup.createMerchant': 'Creează Cont Comerciant',
    'signup.createBank': 'Creează Cont Bancar',
    'signup.orContinueWith': 'Sau continuați cu',
    'signup.haveAccount': 'Aveți deja un cont?',
    'signup.signIn': 'Conectați-vă',
    'signup.errors.emailRequired': 'Email-ul este necesar',
    'signup.errors.invalidEmail': 'Vă rugăm introduceți o adresă de email validă',
    'signup.errors.passwordRequired': 'Parola este necesară',
    'signup.errors.confirmPasswordRequired': 'Vă rugăm confirmați parola',
    'signup.errors.passwordsMismatch': 'Parolele nu se potrivesc',
    'signup.errors.bankAuthRequired': 'Tokenul de Autentificare Bancară este necesar',
    'signup.errors.registrationFailed': 'Înregistrarea a eșuat',
    'signup.errors.emailTaken': 'Acest email este deja înregistrat',
    'signup.errors.invalidBankToken': 'Token de Autentificare Bancară invalid',
    'signup.errors.googleSignInFailed': 'Conectarea cu Google a eșuat. Vă rugăm încercați din nou.',
    'signup.success.registration': 'Înregistrare reușită! Vă conectăm...',
    'signup.success.google': 'Conectarea cu Google a reușit!',
    'signup.passwordStrength.veryWeak': 'Foarte Slabă',
    'signup.passwordStrength.weak': 'Slabă',
    'signup.passwordStrength.medium': 'Medie',
    'signup.passwordStrength.strong': 'Puternică',
    'signup.passwordStrength.veryStrong': 'Foarte Puternică',
  },
  sr: {
    'signup.upgradeGuest': 'Надоградите свој гостујући налог',
    'signup.createAccount': 'Креирајте свој налог',
    'signup.convertGuest': 'Претворите свој гостујући налог ({guestUsername}) у пун налог',
    'signup.chooseAccount': 'Изаберите тип налога и почните',
    'signup.accountType': 'Тип налога',
    'signup.individual': 'Појединац',
    'signup.individualDesc': 'Лични налог за плаћања и трансфере',
    'signup.merchant': 'Трговац',
    'signup.merchantDesc': 'Пословни налог са алатима за продају',
    'signup.bank': 'Банка',
    'signup.bankDesc': 'Интеграција финансијске институције',
    'signup.bankAuthNotice': 'Регистрација банке захтева важећи токен за аутентификацију банке који издаје администратор платформе.',
    'signup.bankAuthToken': 'Токен за аутентификацију банке',
    'signup.bankAuthTokenPlaceholder': 'Унесите ваш токен за аутентификацију банке',
    'signup.email': 'Имејл адреса',
    'signup.emailPlaceholder': 'vi@primer.com',
    'signup.password': 'Лозинка',
    'signup.passwordPlaceholder': 'Креирајте јаку лозинку',
    'signup.confirmPassword': 'Потврдите лозинку',
    'signup.confirmPasswordPlaceholder': 'Поново унесите вашу лозинку',
    'signup.creatingAccount': 'Креирање налога...',
    'signup.createPersonal': 'Креирај лични налог',
    'signup.createMerchant': 'Креирај трговачки налог',
    'signup.createBank': 'Креирај банковни налог',
    'signup.orContinueWith': 'Или наставите са',
    'signup.haveAccount': 'Већ имате налог?',
    'signup.signIn': 'Пријавите се',
    'signup.errors.emailRequired': 'Имејл је обавезан',
    'signup.errors.invalidEmail': 'Молимо унесите важећу имејл адресу',
    'signup.errors.passwordRequired': 'Лозинка је обавезна',
    'signup.errors.confirmPasswordRequired': 'Молимо потврдите вашу лозинку',
    'signup.errors.passwordsMismatch': 'Лозинке се не подударају',
    'signup.errors.bankAuthRequired': 'Токен за аутентификацију банке је обавезан',
    'signup.errors.registrationFailed': 'Регистрација неуспешна',
    'signup.errors.emailTaken': 'Овај имејл је већ регистрован',
    'signup.errors.invalidBankToken': 'Неважећи токен за аутентификацију банке',
    'signup.errors.googleSignInFailed': 'Пријављивање преко Гоогле-а неуспешно. Покушајте поново.',
    'signup.success.registration': 'Регистрација успешна! Пријављујем вас...',
    'signup.success.google': 'Пријављивање преко Гоогле-а успешно!',
    'signup.passwordStrength.veryWeak': 'Веома слабо',
    'signup.passwordStrength.weak': 'Слабо',
    'signup.passwordStrength.medium': 'Средње',
    'signup.passwordStrength.strong': 'Јако',
    'signup.passwordStrength.veryStrong': 'Веома јако',
  },
  pl: {
    'signup.upgradeGuest': 'Ulepsz Swoje Konto Gościa',
    'signup.createAccount': 'Utwórz Swoje Konto',
    'signup.convertGuest': 'Przekonwertuj swoje konto gościa ({guestUsername}) na pełne konto',
    'signup.chooseAccount': 'Wybierz typ konta i zacznij',
    'signup.accountType': 'Typ Konta',
    'signup.individual': 'Osobiste',
    'signup.individualDesc': 'Konto osobiste do płatności i transferów',
    'signup.merchant': 'Sprzedawca',
    'signup.merchantDesc': 'Konto biznesowe z narzędziami sprzedaży',
    'signup.bank': 'Bank',
    'signup.bankDesc': 'Integracja instytucji finansowej',
    'signup.bankAuthNotice': 'Rejestracja banku wymaga ważnego Tokenu Uwierzytelniania Banku wydanego przez administratora platformy.',
    'signup.bankAuthToken': 'Token Uwierzytelniania Banku',
    'signup.bankAuthTokenPlaceholder': 'Wprowadź swój token uwierzytelniania banku',
    'signup.email': 'Adres Email',
    'signup.emailPlaceholder': 'ty@przykład.com',
    'signup.password': 'Hasło',
    'signup.passwordPlaceholder': 'Utwórz silne hasło',
    'signup.confirmPassword': 'Potwierdź Hasło',
    'signup.confirmPasswordPlaceholder': 'Wprowadź ponownie swoje hasło',
    'signup.creatingAccount': 'Tworzenie Konta...',
    'signup.createPersonal': 'Utwórz Konto Osobiste',
    'signup.createMerchant': 'Utwórz Konto Sprzedawcy',
    'signup.createBank': 'Utwórz Konto Bankowe',
    'signup.orContinueWith': 'Lub kontynuuj z',
    'signup.haveAccount': 'Masz już konto?',
    'signup.signIn': 'Zaloguj się',
    'signup.errors.emailRequired': 'Email jest wymagany',
    'signup.errors.invalidEmail': 'Proszę wprowadzić prawidłowy adres email',
    'signup.errors.passwordRequired': 'Hasło jest wymagane',
    'signup.errors.confirmPasswordRequired': 'Proszę potwierdzić swoje hasło',
    'signup.errors.passwordsMismatch': 'Hasła się nie zgadzają',
    'signup.errors.bankAuthRequired': 'Token Uwierzytelniania Banku jest wymagany',
    'signup.errors.registrationFailed': 'Rejestracja nie powiodła się',
    'signup.errors.emailTaken': 'Ten email jest już zarejestrowany',
    'signup.errors.invalidBankToken': 'Nieprawidłowy Token Uwierzytelniania Banku',
    'signup.errors.googleSignInFailed': 'Logowanie przez Google nie powiodło się. Proszę spróbować ponownie.',
    'signup.success.registration': 'Rejestracja zakończona sukcesem! Logowanie...',
    'signup.success.google': 'Logowanie przez Google zakończone sukcesem!',
    'signup.passwordStrength.veryWeak': 'Bardzo Słabe',
    'signup.passwordStrength.weak': 'Słabe',
    'signup.passwordStrength.medium': 'Średnie',
    'signup.passwordStrength.strong': 'Silne',
    'signup.passwordStrength.veryStrong': 'Bardzo Silne',
  },
};
